"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _Select = _interopRequireDefault(require("../Select"));
var _StyledPhoneInput = require("./StyledPhoneInput");
var _dialCodes = _interopRequireDefault(require("./data/dialCodes.json"));
var _excluded = ["code", "dialCode", "name"];
var Option = _Select.default.Option;
function DialCodeAddon(_ref) {
  var dialCodeAddon = _ref.dialCodeAddon,
    onDialCodeChange = _ref.onDialCodeChange,
    defaultSelectedDialCode = _ref.defaultSelectedDialCode;
  var customData,
    valueKey,
    labelKey,
    key,
    renderCustomOption,
    name = 'phoneinput-dialcode';
  if ((0, _typeof2.default)(dialCodeAddon) === 'object') {
    var _dialCodeAddon$name;
    customData = dialCodeAddon.customData;
    valueKey = dialCodeAddon.valueKey;
    labelKey = dialCodeAddon.labelKey;
    key = dialCodeAddon.key;
    renderCustomOption = dialCodeAddon.renderCustomOption;
    name = (_dialCodeAddon$name = dialCodeAddon.name) !== null && _dialCodeAddon$name !== void 0 ? _dialCodeAddon$name : name;
  }
  function handleDialCodeChange(value, record) {
    if (typeof onDialCodeChange === 'function') {
      onDialCodeChange(value, record);
    }
  }
  function renderOption(props) {
    var code = props.code,
      dialCode = props.dialCode,
      name = props.name,
      restOption = (0, _objectWithoutProperties2.default)(props, _excluded);
    if (!customData) {
      return /*#__PURE__*/_react.default.createElement(Option, (0, _extends2.default)({}, restOption, {
        key: code,
        value: dialCode
      }), /*#__PURE__*/_react.default.createElement("span", null, name, " "), /*#__PURE__*/_react.default.createElement("span", null, dialCode));
    } else if (typeof renderCustomOption === 'function') {
      return renderCustomOption(props);
    }
  }
  return /*#__PURE__*/_react.default.createElement(_StyledPhoneInput.StyledDialCodeAddon, {
    dropdownMatchSelectWidth: false,
    prefixCls: "ykb-ui-select-phoneinput",
    data: customData || _dialCodes.default,
    valueKey: key || 'code',
    labelKey: labelKey || 'dialCode',
    defaultValue: defaultSelectedDialCode,
    optionLabelProp: labelKey || 'dialCode',
    renderTemplate: (!customData || renderCustomOption) && renderOption,
    showSearch: true,
    onChange: handleDialCodeChange,
    name: name
  });
}
var _default = exports.default = DialCodeAddon;